import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M3.5 3.5H3.505M3.5 1.5H6C6.25593 1.49999 6.51184 1.59762 6.70711 1.79289L10.2071 5.29289C10.5977 5.68342 10.5977 6.31658 10.2071 6.70711L6.70711 10.2071C6.31658 10.5976 5.68342 10.5976 5.29289 10.2071L1.79289 6.70711C1.59763 6.51184 1.5 6.25592 1.5 6V3.5C1.5 2.39543 2.39543 1.5 3.5 1.5Z" />
  </svg>
);
